<template>
  <div class="band-frame-container">
    <div v-if="is1Shot" class="one-shot-frame">
      <div class="one-shot-frame-left">
        <img :src="logoImage" class="one-shot-frame-left-img" />
        <div class="one-shot-frame-left-event">
          {{ date }}<br />
          {{ campaignText }}
        </div>
      </div>
      <div class="one-shot-frame-right">
        <div class="one-shot-frame-right-cast">
          <div class="one-shot-frame-right-cast-group">
            {{ groupName }}
          </div>
          <div class="one-shot-frame-right-cast-name" :style="nameTextStyle">
            {{ castName }}
          </div>
        </div>
        <div class="one-shot-frame-right-copyright">
          {{ copyright }}
        </div>
      </div>
    </div>
    <div v-else class="two-shot-frame">
      <div class="two-shot-frame-left">
        <div>
          {{ date }}
        </div>
        <div>{{ campaignText }}</div>
      </div>
      <div class="two-shot-frame-center">
        <img :src="logoImage" class="two-shot-frame-center-img" />
      </div>
      <div class="two-shot-frame-right">
        <div class="two-shot-frame-right-cast">
          <div class="two-shot-frame-right-cast-group">
            {{ groupName }}
          </div>
          <div class="two-shot-frame-right-cast-name" :style="nameTextStyle">
            {{ castName }}
          </div>
        </div>
        <div class="two-shot-frame-right-copyright">
          {{ copyright }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from '~/helpers/date'
export default {
  props: {
    castName: {
      type: String,
      required: true
    },
    groupName: {
      type: String,
      required: true
    },
    openDate: {
      type: String,
      required: true
    },
    part: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    copyright: {
      type: String,
      default: ''
    },
    logoImage: {
      type: String,
      default: ''
    },
    campaignText: {
      type: String,
      default: ''
    }
  },
  computed: {
    is1Shot() {
      return this.type === '1shot'
    },
    date() {
      return formatDate(this.openDate, 'D. MMM. YYYY')
    },
    nameTextStyle() {
      const nameLength = this.castName.length
      if (this.is1Shot) {
        if (nameLength === 4) {
          return {
            letterSpacing: '23px',
            marginRight: '-27px'
          }
        }

        if (nameLength === 5) {
          return {
            letterSpacing: '6px',
            marginRight: '-10px'
          }
        }

        if (nameLength === 6) {
          return {
            letterSpacing: '-1px',
            marginRight: '-10px'
          }
        }
      }

      if (nameLength === 4) {
        return {
          letterSpacing: '25px',
          marginRight: '-28px'
        }
      }

      if (nameLength === 5) {
        return {
          letterSpacing: '11px',
          marginRight: '-18px'
        }
      }

      return {
        letterSpacing: '1px',
        marginRight: '-10px'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.band-frame-container {
  * {
    color: white;
    font-family: 'ヒラギノ丸ゴ Pro W4', 'ヒラギノ丸ゴ Pro',
      'Hiragino Maru Gothic Pro', 'ヒラギノ角ゴ Pro W3',
      'Hiragino Kaku Gothic Pro', 'HG丸ｺﾞｼｯｸM-PRO', 'HGMaruGothicMPRO' !important;
  }
}

.one-shot-frame {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 28px 0;
  width: 750px;

  &-left {
    &-img {
      height: 90px;
      display: block;
      pointer-events: none;
    }

    &-event {
      font-size: 15px;
      font-weight: bold;
    }
  }

  &-right {
    &-cast {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      &-group {
        font-size: 21px;
        line-height: 46px;
        margin-right: 12px;
        font-weight: bold;
      }

      &-name {
        font-size: 44px;
        line-height: 46px;
        font-weight: bold;
      }
    }

    &-copyright {
      font-size: 16px;
      text-align: right;
      color: black;
      margin-right: 30px;
      font-weight: bold;
    }
  }
}

.two-shot-frame {
  width: 1000px;
  display: flex;
  padding: 24px 32px 0 46px;
  justify-content: space-between;
  font-weight: bold;
  position: relative;

  &-left {
    font-size: 24px;
    line-height: 1.5;
  }

  &-center {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    display: flex;
    justify-content: center;
    padding-top: 20px;

    &-img {
      display: block;
      height: 100px;
      pointer-events: none;
    }
  }

  &-right {
    &-cast {
      display: flex;
      align-items: center;
      margin-bottom: 30px;
      margin-top: 12px;

      &-group {
        font-size: 20px;
        margin-right: 12px;
        line-height: 24px;
      }

      &-name {
        font-size: 38px;
        line-height: 40px;
      }
    }

    &-copyright {
      font-size: 15px;
      text-align: right;
      color: black;
    }
  }
}
</style>
